import { createFileRoute } from '@tanstack/react-router'
import UserDetail from "@/views/mario/UserDetail";

export const Route = createFileRoute(
  '/_authenticated/_staff/achievements/$userId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams();
  return <UserDetail userId={userId}/>
}
